<template>
  <div>
    <notification-result />
    <mybets-modal v-if="isOpened" :betslip-group-id="betslipId" @close="toggleHistoryModal" />
    <negotiation-modal
      v-if="showNegotiation"
      :negotiation="negotiateData"
      @close="toggleNegotiationModal" />
    <mybets-details-modal
      v-if="showMybetDetailsModal"
      :betDetails="myBetDetailsData"
      :notTopWinnings="notTopWinnings"
      @close-betslip-details="toggleMyBetDetailsModal" />
    <modal-message />
    <odd-tooltip-component />
    <modal-widget />
  </div>
</template>

<script>
  import store from '../../store';
  import OddTooltipComponent from './match/odd-tooltip-component';
  import MybetsModal from '../../components/common/mybets/modals/mybets-modal';
  import MybetsDetailsModal from '../../components/common/mybets/modals/mybets-details-modal';
  import NegotiationModal from '../../components/common/mybets/modals/negotiation-modal';
  import { EventBus } from '../../services/event-bus-service';
  import { BtoPublicBus } from '../../services/bto-event-bus';
  import { BTO_LISTENERS } from '../../models/enums/bto-event-bus-const';
  import MyBetDetailsModel from '../../models/mybets/model-mybet-details';
  import ModalWidget from '@bto-widgets/modal/web';

  export default {
    name: "ModalsComponent",
    data() {
      return {
        isOpened: false,
        isNewNegotiate: true,
        showNegotiation: false,
        showMybetDetailsModal: false,
        myBetDetailsData: {},
        negotiateData: {},
        betslipId: null,
        notTopWinnings: true,
      };
    },
    computed: {
      newNegotiation() {
        return store.state.NegotiationsModule.newNegotiation;
      },
    },
    watch: {
      newNegotiation(val) {
        if (val && APP_SETTINGS.settings.modalNegotiations && !this.showNegotiation) {
          this.negotiateData = val;
          this.showNegotiation = true;
        }
      },
    },
    mounted() {
      EventBus.$on('allmybets', this.handleAllMybets);
      EventBus.$on('detailsonmybets', this.handleDetailsOnMybets);
      EventBus.$on('winnings-details', this.handleWinnings);
      EventBus.$on('betslipChecker', this.handleBetslipChecker);
      EventBus.$on('single-negotiate', this.handleSingleNegotiate);
      EventBus.$on('closeNegotitation', this.handleCloseNegotiation);
      BtoPublicBus.on(BTO_LISTENERS.MYBETS, this.handleAllMybets);
    },
    destroyed() {
      EventBus.$off('allmybets', this.handleAllMybets);
      EventBus.$off('detailsonmybets', this.handleDetailsOnMybets);
      EventBus.$off('winnings-details', this.handleWinnings);
      EventBus.$off('betslipChecker', this.handleBetslipChecker);
      EventBus.$off('single-negotiate', this.handleSingleNegotiate);
      EventBus.$off('closeNegotitation', this.handleCloseNegotiation);
      BtoPublicBus.off(BTO_LISTENERS.MYBETS, this.handleAllMybets);
    },
    methods: {
      handleCloseNegotiation() {
        this.showNegotiation = false;
      },
      handleSingleNegotiate(data) {
        this.negotiateData = data;
        this.showNegotiation = true;
      },
      handleBetslipChecker(betslipCheckerData) {
        this.myBetDetailsData = betslipCheckerData;
        if (betslipCheckerData.g) {
          this.myBetDetailsData = new MyBetDetailsModel(betslipCheckerData);
        }
        this.showMybetDetailsModal = true;
        this.notTopWinnings = true;
        EventBus.$emit('history-details', this.details);
      },
      handleWinnings(winningsData) {
        this.myBetDetailsData = winningsData;
        this.showMybetDetailsModal = true;
        this.notTopWinnings = false;
        EventBus.$emit('history-details', this.details);
      },
      handleAllMybets() {
        if (!store.getters.isUserLogged) {
          return;
        }
        this.betslipId = null;
        this.isOpened = true;
      },
      handleDetailsOnMybets(data) {
        this.betslipId = data;
        this.isOpened = true;
      },
      toggleHistoryModal() {
        this.isOpened = !this.isOpened;
      },
      toggleNegotiationModal() {
        this.showNegotiation = !this.showNegotiation;
      },
      toggleMyBetDetailsModal() {
        this.showMybetDetailsModal = !this.showMybetDetailsModal;
        EventBus.$emit('clear-betslip-widget-checker-code');
        EventBus.$emit('clear-betslip-checker-code');
      },
    },
    components: {
      OddTooltipComponent,
      MybetsModal,
      MybetsDetailsModal,
      NegotiationModal,
      ModalWidget,
    }
  };
</script>
